/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Affiliate Postback Receiver API
 * Production-ready S2S postback ingestion and querying service for affiliate marketing platforms.

## Features
- **Postback Ingestion**: Accept affiliate conversion events via GET/POST webhooks
- **Deduplication**: Automatic duplicate detection to prevent double counting
- **Event Normalization**: Standardize events from multiple affiliate networks
- **Query API**: Search and filter historical events with pagination
- **Analytics**: Statistics aggregations and CSV export for reporting
- **Health Checks**: Kubernetes-ready liveness and readiness probes
- **Metrics**: Prometheus-compatible metrics for monitoring

## Supported Networks
- Referon (via `/postbacks/referon` endpoint)

## Event Types
- **CLICK**: User clicked on affiliate link
- **REG**: User registration
- **FTD**: First-time deposit
- **DEP**: Regular deposit
- **REDEP**: Repeat deposit
 * OpenAPI spec version: 1.0.0
 */

export type EventsControllerCompareStatsComparisonType =
  (typeof EventsControllerCompareStatsComparisonType)[keyof typeof EventsControllerCompareStatsComparisonType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventsControllerCompareStatsComparisonType = {
  day: 'day',
  week: 'week',
  month: 'month',
  custom: 'custom',
} as const;
